"use client";

import { useFormikContext } from "formik";
import Spinner from "react-bootstrap/Spinner";

export function FormButton({
                             label = "Submit",
                             className = "",
                             spinner = "right", // position of spinner
                             mt = "mt-3",
                             loading = false,   // NEW: external override
                           }) {
  const formik = useFormikContext?.(); // guard against missing context

  // use external loading if provided, else fallback to Formik's isSubmitting
  const isSubmitting = loading || formik?.isSubmitting;

  return (
    <div
      className={`d-flex flex-row justify-content-start align-items-center ${mt}`}
    >
      {spinner === "left" && isSubmitting && (
        <Spinner className="me-2" animation="border" size="sm" />
      )}

      <button
        type="submit"
        className={`btn btn-primary ${className}`}
        disabled={isSubmitting}
      >
        {label}
      </button>

      {spinner !== "left" && isSubmitting && (
        <Spinner className="ms-2" animation="border" size="sm" />
      )}
    </div>
  );
}